import type { ReactNode } from "react";
import { useLocation, useNavigate } from "react-router";
import { useAuthActions, useAuthUser } from "@/context/auth/AuthContext";
import { Button } from "@/components/ui/button";

/** Espejo UX del owner-suspended del BFF (#303). Billing permanece ungated. */
export default function BillingAccessBoundary({
  children,
}: {
  children: ReactNode;
}) {
  const user = useAuthUser();
  const { logout } = useAuthActions();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  if (
    user?.type === "owner" &&
    user?.suspended === true &&
    pathname.replace(/\/+$/, "") !== "/mi-suscripcion"
  ) {
    return (
      <section
        className="m-auto flex max-w-xl flex-col gap-4 p-6"
        aria-labelledby="servicio-suspendido"
      >
        <h1
          id="servicio-suspendido"
          className="text-2xl font-semibold text-balance"
        >
          Servicio suspendido
        </h1>
        <p className="text-text-secondary text-pretty">
          Esta sesión no tiene acceso a la operación del negocio. En Mi
          Suscripción podés consultar la deuda, pagar cuando corresponda y ver
          cómo recuperar el servicio.
        </p>
        <div className="flex flex-wrap gap-3">
          <Button
            className="min-h-10"
            onClick={() => navigate("/mi-suscripcion")}
          >
            Ir a Mi Suscripción
          </Button>
          <Button
            className="min-h-10"
            variant="outline"
            onClick={async () => {
              await logout();
              navigate("/login");
            }}
          >
            Cerrar sesión
          </Button>
        </div>
      </section>
    );
  }
  return <>{children}</>;
}
